























import { RootStoreHelper } from '../../core/mixins';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from '../../core/components/Button.vue';
import { ColorsList } from '../../core/utils';

@Component({
    components: {
        Button
    }
})
export default class OpenChatbotButton extends Mixins(RootStoreHelper) {
    btnColor: string = ColorsList.skyblue;
    iconColor: string = 'white';

    toggleChatbot(){
        this.$_chatbotTogglePanel()
    }
}
